
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dogovor-oferty",
      function () {
        return require("private-next-pages/dogovor-oferty/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dogovor-oferty"])
      });
    }
  